import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";

/**
 * Created by jonas on 2021-03-10.
 */

export class MissedWin implements SimplePresentation {

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish(), paused:true});
        tl.add(DasUBoot.winView.getTorpedoMiss());
        tl.play();
    }


    shouldRun():boolean {
        return DasUBoot.model.winRatio <= 0 && !!DasUBoot.model.gameData.torpedo?.isComplete;
    }


}